var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTextBubble = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    viewBox: "0 0 30 20.48",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.96,0H6.04C2.7,0,0,2.7,0,6.04v4.8c0,3.34,2.7,6.04,6.04,6.04h12.81c.02.11.05.21.11.31l1.64,2.84c.34.6,1.21.6,1.55,0l1.64-2.84c.06-.1.09-.21.11-.31h.06c3.34,0,6.04-2.7,6.04-6.04v-4.8c0-3.34-2.7-6.04-6.04-6.04h0ZM5.71,10.98c-1.4,0-2.54-1.14-2.54-2.54s1.14-2.54,2.54-2.54,2.54,1.14,2.54,2.54-1.14,2.54-2.54,2.54ZM15,10.98c-1.4,0-2.54-1.14-2.54-2.54s1.14-2.54,2.54-2.54,2.54,1.14,2.54,2.54-1.14,2.54-2.54,2.54ZM24.29,10.98c-1.4,0-2.54-1.14-2.54-2.54s1.14-2.54,2.54-2.54,2.54,1.14,2.54,2.54-1.14,2.54-2.54,2.54Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTextBubble, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/text_bubble.b5c3ff6e.svg";
export { ForwardRef as ReactComponent };